import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import { FormGroup, FormControl, ControlLabel, ListGroup, ListGroupItem, Breadcrumb } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import ProjectCard from "./ProjectCard";
import config from "../config";
import "./Project.css";
import { s3Upload } from "../libs/awsLib";
import Typography from '@material-ui/core/Typography';
import loaderIcon from'../images/ftc_logo.gif';
import EnhancedTable from "./EnhancedTable";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const rowHeaders = [
  { id: 'version', numeric: false, center: true, disablePadding: true, label: 'Version' },
  { id: 'notes', numeric: false, center: false, disablePadding: false, label: 'Notes' },
  { id: 'active', numeric: false, center: false, disablePadding: true, label: 'Active' },
];

export default class Project extends Component {
  constructor(props) {
    super(props);

    this.file = null;
    this.state = {
      alertOpen: false,
      alertType: '',
      schemaDialogOpen: false,
      dialogEditSchema: null,
      isLoading: true,
      isDeleting: false,
      isSaving: false,
      project: null,
      title: "",
      logo: "",
      attachmentURL: null,
      description: "",
      active: false,
      isDeleting: false,
      multiline: 'Controlled'
    };
  }

  async componentDidMount() {
  if (!this.props.isAuthenticated) {
    return;
  }

    try {
      let attachmentURL;
      const project = await this.getProject();
      const { title, logo, description, schemas, active } = project;


      console.log('SCHEMA');
      console.log(project);

      if (logo) {
        attachmentURL = await Storage.get(logo);
      }

      if (schemas.length === 0) {
        let scm = await this.createNewSchemaVersion(null);
        console.log(scm);
        let newSchemas = [{id: this.getSchemaIdFromSk(scm.sk), version: 1, notes: " ", active: false}];
        project.schemas = newSchemas;
        project.currentSchemaVersion = 1;
        await this.updateProject({
          title: title,
          logo: logo,
          description: description,
          currentSchemaVersion: 1,
          active: active,
          schemas: newSchemas
        });
      }

      const rows = await this.getStructuredSchemasList(project.schemas);
      this.setState({
        isLoading: false,
        project,
        title: title,
        logo: logo,
        attachmentURL,
        description: description,
        active: active,
        rows: rows
      });
    } catch (e) {
      alert(e);
    }
  }
  async getStructuredSchemasList(schemas) {
    var rows = [];
    for (var i = 0; i < schemas.length; ++i) {
      let s = schemas[i];
      const {id, version, notes, active} = s;
      let rowCols = [
        { id: 'version', numeric: false, center: true, disablePadding: true, value: version, type: 'text'},
        { id: 'notes', numeric: false, center: false, disablePadding: false, value: notes, type: 'text' },
        { id: 'active', numeric: false, center: false, disablePadding: true, value: active, type: 'icon_check' },
      ];
      rows.push({id: i + 1, version, notes, active, key: id, cols: rowCols})
    }
    return rows
  }
  updateProject(project) {

    const projectId = this.props.location.state && this.props.location.state.projectId;
    console.log('updateProject');
    console.log(projectId);
    console.log(project);
    try{
      if (this.props.org) {
        return API.put("ftc", `/organisations/${this.props.org.pk}/projects/${projectId}`, {body: project});
      } else {
        return API.put("ftc", `/organisations/user/projects/${projectId}`, {body: project});
      }
    }catch(e) {
      console.log(e);
    }
  }
  getProject() {
    const projectId = this.props.location.state && this.props.location.state.projectId;
    if (this.props.org) {
      return API.get("ftc", `/organisations/${this.props.org.pk}/projects/${projectId}`);
    } else {
      return API.get("ftc", `/organisations/user/projects/${projectId}`);
    }
  }

  deleteSchemas() {
    const idList = this.state.selected;
    console.log('deleteSchemas');
    if (idList.length > 0) {
      const newList = [];
      for (var i = 0; i < idList; ++i) {
        newList.push('SCM|' + idList[i]);
      }
      const body = {ids: newList};
      console.log(body);
      if (this.props.org) {
        return API.del("ftc", `/organisations/${this.props.org.pk}/schemas`, {body: body});
      } else {
        return API.del("ftc", `/organisations/user/schemas`, {body: body});
      }
    }
  }


getSchemaIdFromSk(sk) {
  return sk.substr(4);
}


validateForm() {
  return this.state.title.length > 0;
}

formatFilename(str) {
  return str.replace(/^\w+-/, "");
}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value
  });
}
handleTextFieldChange = name => event => {
  this.state.dialogEditSchema.notes = event.target.value;
    this.setState({

    });
  };
handleFileChange = event => {
  this.file = event.target.files[0];
}

/*
saveProject(project) {
  if (this.props.org) {
    return API.put("ftc", `/organisations/${this.props.org.pk}/projects/${this.props.match.params.id}`, {body: project});
  } else {
    return API.put("ftc", `/organisations/user/projects/${this.props.match.params.id}`, {body: project});
  }
}
*/
handleSubmit = async event => {
  let attachment;

  event.preventDefault();

  if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
    alert("Please pick a file smaller than 5MB");
    return;
  }

  this.setState({ isLoading: true });

  try {
    if (this.file) {
      attachment = await s3Upload(this.file);
    }

    await this.saveOrg({
      orgName: this.state.name,
      logo: attachment || this.state.org.logo,
      category: this.state.category_short,
      categoryDesc: this.state.category
    });
    this.props.history.push("/organisations");
  } catch (e) {
    alert(e);
    this.setState({ isLoading: false });
  }
}

deleteNote() {
  return API.del("ftc", `/notes/${this.props.match.params.id}`);
}

createNewSchemaVersion(cloneId) {
  console.log(cloneId);
  return API.post("ftc", "/projects/schemas", {
    body: { orgId: this.props.org ? this.props.org.pk : null, cloneId: cloneId }
  });

}

/*
handleDelete = async event => {
  event.preventDefault();

  const confirmed = window.confirm(
    "Are you sure you want to delete this note?"
  );

  if (!confirmed) {
    return;
  }

  this.setState({ isDeleting: true });

  try {
    await this.deleteNote();
    this.props.history.push("/");
  } catch (e) {
    alert(e);
    this.setState({ isDeleting: false });
  }
}
*/
/*
handleBuilderClick = event => {
  event.preventDefault();
  sessionStorage.setItem('schema_id', this.state.note.noteId);
  this.props.history.push("/builder");
}
*/
/*
handleSchemaClick = event => {
  event.preventDefault();
  this.props.history.push(event.currentTarget.getAttribute("href"));
}
*/
/*
handleNewSchemaClick = async event => {
  event.preventDefault();
  this.setState({ isLoading: true });
  var maxVersion = 0;
  for (var i = 0; i < this.state.schemas.length; ++i) {
    let schema = this.state.schemas[i];
    maxVersion = schema.version > maxVersion ? schema.version : maxVersion;
  }
  maxVersion += 1;
  let scm = await this.createNewSchemaVersion();
  let newSchema = {id: this.getSchemaIdFromSk(scm.sk), version: maxVersion, notes: " ", active: false};
  this.state.project.schemas.push(newSchema);
  await this.updateProject({
    title: this.state.title,
    logo: this.state.logo,
    description: this.state.description,
    currentSchemaVersion:
    active: this.state.active,
    schemas: this.state.schemas
  });
  this.setState({ isLoading: false, schemas: this.state.project.schemas});
}
*/
/*
handleSaveSchemaClick = async event => {
  event.preventDefault();
  let ou = this.state.orgUsers[event.currentTarget.getAttribute("id")];

  this.setState({ isLoading: true });

  try {
    await this.updateOrgUser({empId: ou.sk,roles: ou.newRoles});
    this.setState({ isLoading: false });
    ou.userRoles = ou.newRoles.slice(0);
    ou.rolesChanged = false;
    //this.state.orgUsers[event.currentTarget.getAttribute("id")] = ou;
    this.setState(({ ou }) => (
      {
        orgUsers: this.state.orgUsers
      }
    ));
  } catch (e) {
    alert(e);
    this.setState({ isLoading: false });
  }




}
*/
/*
handleCancelSchemaClick = event => {
  event.preventDefault();
  let ou = this.state.orgUsers[event.currentTarget.getAttribute("id")];
  ou.newRoles = ou.userRoles.slice(0);
  ou.rolesChanged = false;
  this.state.orgUsers[event.currentTarget.getAttribute("id")] = ou;
  this.setState(({ ou }) => (
    {
      orgUsers: this.state.orgUsers
    }
  ));

}
*/
/*
handleDeleteSchemaClick = async event => {
  event.preventDefault();
  let idx = event.currentTarget.getAttribute("id");
  let ou = this.state.orgUsers[idx];
  const confirmed = window.confirm(
    "Are you sure you want to delete this user?"
  );

  if (!confirmed) {
    return;
  }

  this.setState({ isLoading: true });

  try {
    await this.deleteOrgUser({empId: ou.sk});
    this.setState({ isLoading: false });
    this.state.orgUsers.splice(idx, 1);
    this.setState(({ ou }) => (
      {
        orgUsers: this.state.orgUsers
      }
    ));
  } catch (e) {
    alert(e);
    this.setState({ isLoading: false });
  }
}
*/
handleViewTripsClick = (event, selected) => {
  event.preventDefault();
  let p = this.state.project;
  let pId = p.sk.replace(/PRJ\|/, "");
  let version = null;
  let schemaNotes = '';
  for (var i = 0; i < this.state.project.schemas.length; ++i) {
    let xSchema = this.state.project.schemas[i];
    if (xSchema.id == selected[0]) {
      version = xSchema.version;
      schemaNotes = xSchema.notes;
      break;
    }
  }

  this.props.history.push({
    pathname: '/projects/schemas/trips',
    state: { projectId: pId, projectTitle: p.title, schemaId: selected[0], version: version, logo: this.state.attachmentURL, notes: schemaNotes}
  });
  //this.props.history.push(`/projects/${pId}/trips`);
}

handleSchemaVersionActiveChange = name => event => {
  this.state.dialogEditSchema.active = event.target.checked;
    this.setState({

    });


}

/*
toggleCheckboxChange = event => {
  var ou = this.state.orgUsers[event.currentTarget.getAttribute("id")];
  let cat = event.currentTarget.getAttribute("value");
  let idxNew = ou.newRoles.indexOf(cat);
  let idx = ou.userRoles.indexOf(cat);
  //console.log(idx);
  //console.log(idxNew);
  //console.log(ou.newRoles);
  if (idxNew > -1) {
    ou.newRoles.splice(idxNew, 1);
  } else {
    ou.newRoles.push(cat);
  }
  ou.newRoles.sort();
  //console.log(ou.userRoles);
  //console.log(ou.newRoles);

  ou.rolesChanged = false;

   if (ou.userRoles === ou.newRoles) {
      ou.rolesChanged = false;
   } else if (ou.userRoles == null || ou.newRoles == null) {
      ou.rolesChanged = true;
   } else if (ou.userRoles.length != ou.newRoles.length) {
      ou.rolesChanged = true;
   } else {
    for (var i = 0; i < ou.userRoles.length; ++i) {
      if (ou.userRoles[i] !== ou.newRoles[i]) {
        ou.rolesChanged = true;
      };
    }
}
  //console.log(ou.rolesChanged);


  this.state.orgUsers[event.currentTarget.getAttribute("id")] = ou;
    this.setState(({ ou }) => (
      {
        orgUsers: this.state.orgUsers
      }
    ));
  }

  */
handleCrumbClick = event => {
  event.preventDefault();
  this.props.history.push(event.currentTarget.getAttribute("href"));
}
handleAlertClose = () => {
    this.setState({ alertOpen: false, alertType: '' });
};
handleSchemaDialogClose= () => {
    this.setState({ schemaDialogOpen: false, dialogEditSchema: null });
};

handleSchemaDialogSave = async () => {
  const schema = this.state.dialogEditSchema;
  this.setState({ schemaDialogOpen: false, dialogEditSchema: null, isSaving: true });
  if (schema.id == '') {
    if (schema.notes == '') {
      schema.notes = ' ';
    }
    let scm = await this.createNewSchemaVersion(schema.cloneId);
    console.log(scm);
    schema.id = this.getSchemaIdFromSk(scm.sk);
    if (schema.cloneId) {
      delete schema.cloneId;
    }
    this.state.project.schemas.push(schema);
    console.log(schema);
    this.state.project.currentSchemaVersion = schema.version;
    await this.updateProject({
      title: this.state.project.title,
      logo: this.state.project.logo,
      description: this.state.project.description,
      currentSchemaVersion: schema.version,
      active: this.state.project.active,
      schemas: this.state.project.schemas
    });
  } else {
    for (var i = 0; i < this.state.project.schemas.length; ++i) {
      let xSchema = this.state.project.schemas[i];
      if (xSchema.id == schema.id) {
        this.state.project.schemas[i] = schema;
          await this.updateProject({
            title: this.state.project.title,
            logo: this.state.project.logo,
            description: this.state.project.description,
            currentSchemaVersion: this.state.project.currentSchemaVersion,
            active: this.state.project.active,
            schemas: this.state.project.schemas
          });
        break;
      }
    }

  }
  const rows = await this.getStructuredSchemasList(this.state.project.schemas);
  this.setState({ isSaving: false , rows: rows, selected: null});
}


handleActivateClick = event => {
  event.preventDefault();
  console.log(event);
  this.setState({
    alertOpen: true,
    alertType: 'activate',
  });
}
changeProjectLiveState = async event =>  {
  this.state.project.active = !this.state.project.active;
  this.setState({
    alertOpen: false,
    alertType: '',
    active: this.state.project.active
  });
  this.updateProject({
    title: this.state.project.title,
    logo: this.state.project.logo,
    description: this.state.project.description,
    currentSchemaVersion: this.state.project.currentSchemaVersion,
    active: this.state.project.active,
    schemas: this.state.project.schemas
  });
}

/*
handleBuilderClick = (event,id) => {
  event.preventDefault();
  let schema = this.state.project.schemas[event.target.id];
  //console.log('.........................');
  //console.log(schema);
  //console.log(this.props.org);
  //console.log('.........................');
  //let schemaId = this.state.project.schemas[event.target.id].id;
  sessionStorage.setItem('schema_version', schema.version);
  sessionStorage.setItem('schema_id', schema.id);
  sessionStorage.setItem('org_id', this.props.org ? this.props.org.pk : 'user');
  sessionStorage.setItem('project_name', this.state.title);
  sessionStorage.setItem('project_logo', this.state.attachmentURL);
  if (this.props.org) {
    sessionStorage.setItem('org_name', this.props.org.orgName);
    sessionStorage.setItem('org_logo', this.props.org.logo);
  } else {
    sessionStorage.setItem('org_name', '');
    sessionStorage.setItem('org_logo', '');
  }


  this.props.history.push("/builder");
  //this.props.history.push("/graph");
}
*/
/*
handleTripsClick = event => {
  event.preventDefault();
  let p = this.state.project;


  let pId = p.sk.replace(/PRJ\|/, "");
//var replaced = text.replace(/PRJ\|/, "");

  console.log(p.sk);
  console.log(pId);
  console.log(p);
  this.props.history.push(`/projects/${pId}/trips`);
}
*/

handleSchemaClick = (event, schemaSk) => {
  event.preventDefault();
  console.log(schemaSk);
  let schema = null;
  for (var i = 0; i < this.state.project.schemas.length; ++i) {
    let sch = this.state.project.schemas[i];
    if (sch.id === schemaSk) {
      schema = sch;
      break;
    }
  }
  if (schema) {
    this.loadBuilder(schema);
  }
}

loadBuilder(schema) {
  sessionStorage.setItem('schema_version', schema.version);
  sessionStorage.setItem('schema_id', schema.id);
  sessionStorage.setItem('org_id', this.props.org ? this.props.org.pk : this.props.user.pk); // 'user'
  sessionStorage.setItem('project_name', this.state.title);
  sessionStorage.setItem('project_logo', this.state.attachmentURL);
  if (this.props.org) {
    sessionStorage.setItem('org_name', this.props.org.orgName);
    sessionStorage.setItem('org_logo', this.props.org.logo);
  } else {
    sessionStorage.setItem('org_name', '');
    sessionStorage.setItem('org_logo', '');
  }
  console.log(window.location);
  this.props.history.push("/builder");
}






handleSchemaEditClick = (event, selected) => {
  event.preventDefault();
  //console.log(selected);
  //console.log(this.state.project);
  for (var i = 0; i < this.state.project.schemas.length; ++i) {
    let schema = this.state.project.schemas[i];
    if (schema.id == selected[0]) {
      this.setState({
        schemaDialogOpen: true,
        dialogEditSchema: schema
      });
      break;
    }
  }
}
handleCreateSchemaClick = async event => {
  event.preventDefault();
  let newSchema = {id: '', version: this.state.project.currentSchemaVersion + 1, notes: '', active: false};
  this.setState({
    schemaDialogOpen: true,
    dialogEditSchema: newSchema
  });
}
handleCloneSchemaClick = async (event, selected) => {
  event.preventDefault();
  for (var i = 0; i < this.state.project.schemas.length; ++i) {
    let schema = this.state.project.schemas[i];
    if (schema.id == selected[0]) {
      let clonedSchema = {id: '', cloneId: schema.id, version: this.state.project.currentSchemaVersion + 1, notes: 'Cloned from version ' + schema.version, active: false};
      this.setState({
        schemaDialogOpen: true,
        dialogEditSchema: clonedSchema
      });
      break;
    }
  }
}

handleDeleteSchemaClick = async (event, selected) => {
  event.preventDefault();
  let count = selected.length;
  if (count > 0) {
    this.setState({
      alertOpen: true,
      alertType: 'delete',
      selected: selected
    });
  }
}
 handleDeleteSchemas = async (event) => {
   this.setState({
     alertOpen: false,
     alertType: '',
     isDeleting: true
   });
   const newSchemas = [];
   for (var i = 0; i < this.state.project.schemas.length; ++i) {
     let xSchema = this.state.project.schemas[i];
     let found = false;
     for (var ii = 0; ii < this.state.selected.length; ++ii) {
       let sel = this.state.selected[ii];
       console.log(xSchema.id, sel, xSchema.id === sel)
       if (xSchema.id === sel) {
         found = true;
         break;
       }
     }
     if (!found) {
       newSchemas.push(xSchema);
     }
   }
   console.log(newSchemas);
   if (newSchemas.length == 0) {
     this.state.project.currentSchemaVersion = 0;
   }
   try {
     await this.updateProject({
       title: this.state.project.title,
       logo: this.state.project.logo,
       description: this.state.project.description,
       currentSchemaVersion: this.state.project.currentSchemaVersion,
       active: this.state.project.active,
       schemas: newSchemas
     });

     const result = await this.deleteSchemas();
     console.log(result);
     if (result.status == true) {
       this.state.project.schemas = newSchemas;
       const rows = await this.getStructuredSchemasList(this.state.project.schemas);
       this.setState({
         isDeleting: false,
         rows: rows,
         selected: null
       });
     } else {
       // add alert here
       console.log('Failed to delete schemas of cloud');
       this.setState({
         isDeleting: false,
         selected: null
       });
     }
   } catch (e) {
     this.setState({
       isDeleting: false,
       selected: null
     });
     alert(e);
   }

   /*
  this.setState({ isDeleting: true, alertOpen: false, alertType: ''});
  console.log('aaa');
  let isSuccess = false
  try {
    const result = await this.deleteProjects();
    console.log(result);
    isSuccess = true;
  } catch (e) {
    alert(e);
  }

  console.log('ddd');
  const projects = await this.getOrgProjects();
  const rows = await this.getStructuredSchemasList(projects);
  console.log('LEN: ', rows.length);
  this.setState({ isDeleting: false, projects: projects, rows: rows });
  */
}



renderLoader() {
  const label = this.state.isDeleting ? 'deleting...' : this.state.isSaving ? 'saving...' : 'loading...';
  return(

    <div id="splash" style={{paddingTop: 250, zIndex:999}}>

      <center id="splash">
        <img src={loaderIcon}/>
        <Typography style={{padding: '4px'}} variant="caption">{label}</Typography>
      </center>
    </div>



  )
}
renderSchemas() {
  const menuItems = [
    { id: 0, label: 'Create new...', lt: Number.MAX_VALUE, gt: 0, isOrOperator: false, action: this.handleCreateSchemaClick, divider: false, type: 'create' },
    { id: 1, label: 'Clone...', lt: 1, gt: 1, isOrOperator: true, action: this.handleCloneSchemaClick, divider: false, type: 'clone' },
    { id: 2, label: 'Edit...', lt: 1, gt: 1, isOrOperator: true, action: this.handleSchemaEditClick, divider: false, type: 'edit'},
    { id: 3, label: 'Delete', lt: 1, gt: -1, isOrOperator: false, action: this.handleDeleteSchemaClick, divider: true, type: 'delete' },
    { id: 4, label: 'View trips...', lt: 1, gt: 1, isOrOperator: true, action: this.handleViewTripsClick, divider: false, type: 'view' }
  ];
    return (
        <div>
          {!this.state.isLoading && <EnhancedTable
                                        logosKey={this.state.key}
                                        title='Schema Versions'
                                        tooltip=''
                                        items={this.state.rows}
                                        menuItems={menuItems}
                                        handleItemClick={this.handleSchemaClick}
                                        rowHeaders={rowHeaders}
                                        orderBy='version'
                                        order='desc'
                                        />}
          </div>
    );
  }

render() {
  //const { classes } = this.props;
  return (
  <div>
         <Breadcrumb  style={{top: 58, left: 66, right: 0, position: 'absolute', zIndex:999, backgroundColor: '#FFF'}}>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item onClick={this.handleCrumbClick} href="/Projects">Projects</Breadcrumb.Item>
          <Breadcrumb.Item active>{this.state.title}</Breadcrumb.Item>
        </Breadcrumb>
    <div className="Project" style={{position: 'absolute', left:80, right:80,top: 104, paddingBottom:50}}>
      {!this.state.isLoading && this.state.project && <ProjectCard
        title={this.state.title}
        description={this.state.description}
        logo={this.state.attachmentURL}
        active={this.state.active}
        onClick={this.handleActivateClick}
        colour={'#FAFcFA'}
        />}
        {this.state.isLoading || this.state.isDeleting || this.state.isSaving ? this.renderLoader() : this.renderSchemas()}
    </div>
    <Dialog
        open={this.state.alertOpen && this.state.alertType != ''}
        onClose={this.handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{this.state.alertType == 'activate' ? (this.state.active ? 'Deactivate Project' : 'Activate Project') : 'Delete Schema Version'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {this.state.alertType == 'activate' ? (this.state.active ? 'Users will not have access to this projects active schemas.' : 'This projects active schemas will be available for use on users survey devices.') : 'Are you sure you wish to delete the selected schema versions? This cannot be undone.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleAlertClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={this.state.alertType == 'activate' ? this.changeProjectLiveState : this.handleDeleteSchemas} color="primary" autoFocus>
            {this.state.alertType == 'activate' ? (this.state.active ? 'Deactivate' : 'Activate') : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
         open={this.state.schemaDialogOpen}
         onClose={this.handleSchemaDialogClose}
         aria-labelledby="form-dialog-title"
         maxWidth="sm"
         fullWidth
       >
         <DialogTitle id="form-dialog-title">{this.state.dialogEditSchema && this.state.dialogEditSchema.id == '' ? 'Create Schema Version' : 'Edit Schema Version'}</DialogTitle>
         <DialogContent>
           <DialogContentText>
             Schema version {this.state.dialogEditSchema && this.state.dialogEditSchema.version}
           </DialogContentText>
           <TextField
            autoFocus
            fullWidth
            id="filled-multiline-flexible"
            label="Notes"
            multiline
            rowsMax="4"

            value={this.state.dialogEditSchema ? this.state.dialogEditSchema.notes : ''}
            onChange={this.handleTextFieldChange(this.state.dialogEditSchema && this.state.dialogEditSchema.notes)}
            margin="normal"
            variant="filled"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.dialogEditSchema ? this.state.dialogEditSchema.active : false}
                onChange={this.handleSchemaVersionActiveChange('checkedG')}
                value="checkedG"
                style={{color: green[600], '&$checked': { color: green[500]}}}
              />
            }
            label="Active"
          />
         </DialogContent>
         <DialogActions>
           <Button onClick={this.handleSchemaDialogClose} color="primary">
             Cancel
           </Button>
           <Button onClick={this.handleSchemaDialogSave} color="secondary">
             Save
           </Button>
         </DialogActions>
       </Dialog>
    </div>

  );
}
}



// WEBPACK FOOTER //
// ./src/containers/Project.js